import React from 'react';
import { Formik } from 'formik';
import {
    TextField,
    withStyles,
    Button,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    CircularProgress,
    FormHelperText,
    createMuiTheme
} from '@material-ui/core';
import * as Yup from 'yup';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { isSuperUser } from '../../../../sc-utilities';
import { ThemeProvider } from '@material-ui/styles';
import {getDateFormat} from "../../../../sc-utilities/date";

const defaultMaterialThemeAdmin = createMuiTheme({
    palette: {
        primary: { 500: '#0C5A99' }
    }
});

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: { 500: '#140D8A' }
    }
});

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        width: '100%',
        marginTop: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: '100%'
    },

    datePicker: {
        width: '100%'
    }
});

const SoftwareLicenseForm = props => {
    const {
        classes,
        formSettings,
        initialValues,
        handleSubmit,
        translations,
        statuses,
        licensePrototypes,
        editForm,
        loading
    } = props;

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;

                return (
                    <form onSubmit={handleSubmit}>
                        <Typography variant={'h6'}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <TextField
                            name="Name"
                            value={values.Name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.Name && touched.Name)}
                            placeholder={translations["name"] || 'Name'}
                            label={translations["name"] || 'Name'}
                            margin={'dense'}
                            fullWidth={true}
                            type="text"
                        />
                        <TextField
                            disabled={editForm}
                            name="SecretKey"
                            value={values.SecretKey}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.SecretKey && touched.SecretKey)}
                            placeholder={translations["secret_key"] || 'Secret key'}
                            label={translations["secret_key"] || 'Secret key'}
                            margin={'dense'}
                            fullWidth={true}
                            type="text"
                        />
                        <FormControl className={classes.formControl} margin={'dense'}>
                            <InputLabel shrink>{translations["billing_plan_status_text"] || "Please select software license status"}</InputLabel>
                            <Select name="Status" margin={'dense'} value={values.Status} onChange={handleChange}>
                                {statuses.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.displayValue}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <ThemeProvider theme={isSuperUser() ? defaultMaterialThemeAdmin : defaultMaterialTheme}>
                            <FormHelperText>{translations["software_license_please_select_expires_at"] || 'Please select expire date (leave empty if license software does not have expiration date)'}</FormHelperText>
                            <KeyboardDatePicker
                                className={classes.datePicker}
                                clearable={true}
                                onChange={date => setFieldValue('ExpiresAt', date)}
                                format={getDateFormat()}
                                value={values.ExpiresAt}
                                margin="dense"
                                placeholder={translations["expiration_date"] || 'Expiration date'}
                                disablePast={true}
                            />
                        </ThemeProvider>
                        <FormControl className={classes.formControl} margin={'dense'}>
                            <InputLabel shrink>{translations["license_prototype_text"] || "Please select license prototype"}</InputLabel>
                            <Select disabled={editForm} name="LicensePrototypeID" margin={'dense'} value={values.LicensePrototypeID} onChange={handleChange}>
                                {licensePrototypes.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.displayValue}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                disabled={loading || !(isValid && dirty) || isSubmitting}
                            >
                                {isSubmitting || loading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                        formSettings.ButtonSubmit.Title
                                    )}
                            </Button>
                        ) : null}
                    </form>
                );
            }}
        </Formik>
    );
};

export default withStyles(styles, { withTheme: true })(SoftwareLicenseForm);
